import {
	createLogContext,
	shouldLog,
	notifyLogObservers,
	allLogTypes as logTypes
} from './logHandler';
const tagNameCache = {};

const defaults = {
	support: 'https://developer.servicenow.com/now-experience-ui-framework/support',
	module: '@servicenow/ui-core'
};

const logOptionDefaults = {
	level: logTypes.WARN,
	error: null,
	always: false,
	docs: null,
	tagName: null,
	componentId: null
};

/**
 * Creates a logger.
 * @function createLogger
 * @private
 * @param {Object} config - The logger configuration.
 * @param {string} [config.support] - Link to NX UI Documentation & Support
 * @param {string} [config.module] - Module name.
 */
export default function createLogger(options = {}) {
	const loggerOptions = {...defaults, ...options};
	const {module, support} = loggerOptions;
	const postfix = `Visit ${support} for more information about UI Framework on Next Experience.`;
	return async function log(message, options = {}) {
		const logOptions = {...logOptionDefaults, message, module, postfix, ...options};
		const resolvedLogContext = createLogContext(logOptions);
		if (shouldLog(resolvedLogContext, logOptions)) {
			const {level} = logOptions;
			const logger = console[level] || console.log; // eslint-disable-line no-console
			const {componentName, logMessage} = resolvedLogContext;
			if (componentName) {
				if (componentName in tagNameCache && message in tagNameCache[componentName]) return;

				tagNameCache[componentName] = tagNameCache[componentName] || {};
				tagNameCache[componentName][message] = true;
			}
			logger(logMessage);
			notifyLogObservers(resolvedLogContext);
		}
	};
}
